<div
  [matTooltip]="isOverflowing ? text : ''"
  [matTooltipDisabled]="!isOverflowing"
  [matTooltipPositionAtOrigin]="true"
  matTooltipTouchGestures="off"
  matTooltipMobileTap="off"
  matTooltipClass="text-overflow-tooltip"
  #textContainer
  (mouseenter)="checkOverflow()"
  (mouseleave)="tooltip.hide()"
>
  {{ text }}
</div>
